var React = require('react');

function BookmarkIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"bookmark","d":"M2.8 0h14.4v20L10 13.8 2.8 20"}));
}

BookmarkIcon.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = BookmarkIcon;

BookmarkIcon.default = BookmarkIcon;
